import { render } from "./CommentsPopup.vue?vue&type=template&id=0b970b8e&scoped=true"
import script from "./CommentsPopup.vue?vue&type=script&lang=js"
export * from "./CommentsPopup.vue?vue&type=script&lang=js"

import "./CommentsPopup.vue?vue&type=style&index=0&id=0b970b8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b970b8e"]])

export default __exports__